module.exports = __webpack_public_path__ + "static/img/ikonaIrfan-ON.8d4962e4.png";